/**
 * Wheel Options Surcharge Configuration
 * Maps specific customization option selections to surcharge variant IDs
 * 
 * Product: "Wheel Options Surcharge" (ID: 9946006749431)
 * 
 * This product contains variants for specific customization features:
 * - Materials Upgrade ($19) - ID: 50664014610679
 * - LED Display Strip ($149) - ID: 50664014643447
 * - Airbag - Smooth Leather ($29) - ID: 50664014676215
 * - Airbag - Alcantara ($49) - ID: 50664014708983
 * - Heating Functionality ($79) - ID: 50664014741751
 * - Lane Assist Function ($79) - ID: 50664014774519
 * 
 * The system automatically detects which surcharge variants to add based on
 * the customer's option selections.
 */

// ============ CONFIGURATION ============
// "Wheel Options Surcharge" product ID
window.WHEEL_CUSTOMIZATION_ADDON_PRODUCT_ID = 9946006749431;

// Map of option selection patterns to surcharge variant IDs
// When a customer selects an option that matches a key, the variant is added to cart
// Format: "PropertyName:OptionValue" -> variant_id
//
// Examples:
// - "LED Display Strip:None" -> don't add (free option)
// - "LED Display Strip:Advanced" -> add variant 50664014643447 ($149)
// - "Airbag Cover:yes" -> check material selection next
// - "Airbag Material:Alcantara" -> add variant 50664014708983 ($49)
//
window.SURCHARGE_OPTION_MAP = {
  // LED Display Strip - match actual selected label values
  "LED Display Strip:LED display": 50664014643447,      // $149
  "LED Display Strip:Advanced": 50664014643447,         // Alternative naming
  "LED Display Strip:Premium": 50664014643447,          // Alternative naming
  "LED Display Strip:Basic with Advanced": 50664014643447,

  // Airbag Cover questions - "yes" or "no"
  // Heating Functionality - "yes" or "no"  
  // These are detected, then Airbag Material is checked
  
  // Airbag Materials (only apply if airbag is selected as "yes")
  "Airbag Material:Alcantara": 50664014708983,         // $49
  "Airbag Material:Alcantara Red": 50664014708983,
  "Airbag Material:Alcantara Black": 50664014708983,
  "Airbag Material:Black Suede/Alcantara": 50664014708983,
  "Airbag Material:Smooth Leather": 50664014676215,    // $29
  "Airbag Material:Black Smooth Leather": 50664014676215,

  // Heating & Lane Assist - match exact property names
  "Retain Heating:yes": 50664014741751,                // $79
  "Retain Lane Assist:yes": 50664014774519,            // $79

  // Materials Upgrade (for premium materials)
  "Wheel Trim:Carbon Fiber": 50664014610679,           // $19
  "Wheel Trim:Forged Carbon": 50664014610679,          // $19
  "Wheel Side Materials:Alcantara": 50664014610679,    // $19 upgrade
  "Wheel Side Materials:Premium Leather": 50664014610679,
  "Stitching Color:Premium": 50664014610679,           // Premium stitching = $19 upgrade
};

/**
 * Get surcharge variant IDs for selected options
 * Analyzes customer selections and returns array of applicable surcharge variants
 * @param {Object} properties - Key-value pairs of selected options (from form properties)
 * @returns {Array} - Array of variant IDs to add to cart (may be empty)
 */
window.getSurchargeVariantsForOptions = function(properties) {
  const variants = [];
  const addedVariants = new Set(); // Prevent duplicates
  
  console.log('=== WVC: getSurchargeVariantsForOptions ===');
  console.log('Input properties:', properties);
  console.log('Available map keys:', Object.keys(window.SURCHARGE_OPTION_MAP || {}));
  
  if (!window.SURCHARGE_OPTION_MAP) {
    console.warn('SURCHARGE_OPTION_MAP not found');
    return variants;
  }
  
  // Check each property against the surcharge map
  for (const [optionKey, optionValue] of Object.entries(properties)) {
    if (!optionValue || optionValue === '') continue;
    
    const mapKey = `${optionKey}:${optionValue}`;
    let variantId = window.SURCHARGE_OPTION_MAP[mapKey];

    if (!variantId) {
      if (optionKey === 'Wheel Trim' && /carbon/i.test(optionValue)) {
        variantId = 50664014610679;
      } else if (optionKey === 'Wheel Side Materials' && /(alcantara|premium|perf|leather)/i.test(optionValue)) {
        variantId = 50664014610679;
      } else if (optionKey === 'Stitching Color' && /premium/i.test(optionValue)) {
        variantId = 50664014610679;
      }
    }

    console.log(`  Checking "${mapKey}"... ${variantId ? '✓ MATCHED' : '✗ no match'}`);

    if (variantId) {
      if (!addedVariants.has(variantId)) {
        variants.push(variantId);
        addedVariants.add(variantId);
        console.log(`    → Adding variant ${variantId}`);
      }
    }
  }
  
  console.log(`Result: ${variants.length} surcharge variant(s)`, variants);
  return variants;
};

/**
 * Helper: Fetch and log all variants from Wheel Options Surcharge product
 * (for debugging/setup)
 */
window.logWheelOptionsSurchargeVariants = function() {
  const productId = window.WHEEL_CUSTOMIZATION_ADDON_PRODUCT_ID;
  if (!productId) {
    console.error('WHEEL_CUSTOMIZATION_ADDON_PRODUCT_ID not set');
    return;
  }
  
  fetch(`/admin/api/2024-01/products/${productId}/variants.json`, {
    headers: {
      'Content-Type': 'application/json',
    }
  })
  .then(r => r.json())
  .then(data => {
    console.log('=== WHEEL OPTIONS SURCHARGE VARIANTS ===');
    data.variants.forEach(v => {
      console.log(`${v.title}: ID=${v.id}, Price=$${v.price}`);
    });
  })
  .catch(e => console.error('Error fetching variants:', e));
};
